import { usePermissions } from "../../../infrastructure/hooks/usePermissions";
import { ISwipableAction } from "../types/ItemsList.types";

export const useItemsListPermissions = <
  TItem extends { [key: string]: any }
>() => {
  const { userHavePermissionsByRoute, userHavePermissions } = usePermissions();

  const hasActionPermission = (
    action: ISwipableAction<TItem>,
    item: TItem
  ): boolean => {
    // If action has custom validator that returns false, no permission
    if (action.validator && !action.validator(item)) {
      return false;
    }

    // Get permission route - prefer permissionRoute, fallback to endpoint
    const permissionRoute = action.permissionRoute || action.endpoint;

    // If no route specified, everyone has access
    if (!permissionRoute) {
      return true;
    }

    // Check permissions using the same logic as useAddAdditionalLayoutButton
    return (
      userHavePermissionsByRoute(permissionRoute) ||
      userHavePermissions(permissionRoute)
    );
  };

  const filterActionsByPermissions = (
    actions: ISwipableAction<TItem>[] | undefined,
    item: TItem
  ): ISwipableAction<TItem>[] => {
    if (!actions) return [];

    return actions.filter((action) => hasActionPermission(action, item));
  };

  return {
    hasActionPermission,
    filterActionsByPermissions,
  };
};
